import { render, staticRenderFns } from "./ItemComment.vue?vue&type=template&id=7f6bc587&scoped=true"
import script from "./ItemComment.vue?vue&type=script&lang=js"
export * from "./ItemComment.vue?vue&type=script&lang=js"
import style0 from "./ItemComment.vue?vue&type=style&index=0&id=7f6bc587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bc587",
  null
  
)

export default component.exports